// Botón "Ver portafolio": abre el portafolio del país activo + la unidad de negocio
// seleccionada en el filtro (con respaldo a General en el backend).
import type { JSX } from "react";
import { useQuery } from "@tanstack/react-query";
import { FileText } from "lucide-react";
import { api } from "../lib/api.ts";
import { getCountry } from "../lib/country.ts";
import { Button } from "./ui.tsx";

export function ViewPortfolioButton({ businessUnitId }: { businessUnitId?: string | undefined }): JSX.Element | null {
  const meta = useQuery<{ exists: boolean }>({
    queryKey: ["portfolio-meta"],
    queryFn: () => api.get("/settings/portfolio/meta"),
    staleTime: 60_000,
  });
  if (!meta.data?.exists) return null;

  const open = (): void => {
    const c = getCountry(); // "CO" | "PE" | "ALL"
    const p = new URLSearchParams();
    if (c === "CO" || c === "PE") p.set("country", c);
    if (businessUnitId) p.set("businessUnitId", businessUnitId);
    const qs = p.toString();
    window.open(`/api/v1/settings/portfolio${qs ? `?${qs}` : ""}`, "_blank", "noopener");
  };

  return (
    <Button onClick={open}>
      <FileText size={16} strokeWidth={1.75} /> Ver portafolio
    </Button>
  );
}
